module.exports = __webpack_public_path__ + "static/media/Class-mob.6676abfa.jpg";